import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from '../static/styles/CannonClashInstructions.module.css';

const AimTrainInstructions = ({ isOpen, onClose }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    if (!isOpen) return null;

    const handleTournamentsNavigation = () => {
        onClose();
        navigate('/tournaments');
    };

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h2>{t('aimtrain.title')}</h2>
                    <button className={styles.closeButton} onClick={onClose}>×</button>
                </div>

                <div className={styles.content}>
                    <div className={styles.section}>
                        <h3>{t('aimtrain.howToJoin.title')}</h3>
                        <ol>
                            <li><strong>{t('aimtrain.howToJoin.join')}</strong> - {t('aimtrain.howToJoin.joinDesc')}</li>
                            <li><strong>{t('aimtrain.howToJoin.receiveDetails')}</strong> - {t('aimtrain.howToJoin.receiveDetailsDesc')}:
                                <ul>
                                    <li>{t('aimtrain.howToJoin.roomId')}</li>
                                    <li>{t('aimtrain.howToJoin.matchTime')}</li>
                                </ul>
                            </li>
                            <li><strong>{t('aimtrain.howToJoin.enterMatch')}</strong> - {t('aimtrain.howToJoin.enterMatchDesc')}
                                <ol>
                                    <li>{t('aimtrain.howToJoin.gotoTournaments')} <span onClick={handleTournamentsNavigation} className={styles.tournamentLink}>https://esl.game/tournaments</span></li>
                                    <li>{t('aimtrain.howToJoin.playNow')}</li>
                                    <li>{t('aimtrain.howToJoin.enterRoomId')}</li>
                                    <li>{t('aimtrain.howToJoin.submit')}</li>
                                </ol>
                            </li>
                            <li><strong>{t('aimtrain.gameSetup')}</strong> - {t('aimtrain.gameSetupDesc')}</li>
                            <li><strong>{t('aimtrain.controls')}</strong>
                                <ul>
                                    <li>{t('aimtrain.controls.desktop')}</li>
                                    <li>{t('aimtrain.controls.mobile')}</li>
                                </ul>
                            </li>
                            <li><strong>{t('aimtrain.objective')}</strong>
                                <ul>
                                    <li>{t('aimtrain.objective.eliminate')}</li>
                                    <li>{t('aimtrain.objective.survive')}</li>
                                </ul>
                            </li>
                        </ol>
                    </div>

                    <div className={styles.section}>
                        <h3>{t('aimtrain.rules.title')}</h3>
                        <ul>
                            <li><strong>{t('aimtrain.rules.formatLabel')}</strong> {t('aimtrain.rules.format')}</li>
                            <li><strong>{t('aimtrain.rules.joiningLabel')}</strong> {t('aimtrain.rules.joining')}</li>
                            <li><strong>{t('aimtrain.rules.noShowLabel')}</strong> {t('aimtrain.rules.noShow')}</li>
                            <li><strong>{t('aimtrain.rules.progressionLabel')}</strong> {t('aimtrain.rules.progression')}</li>
                            <li><strong>{t('aimtrain.rules.nextRoundsLabel')}</strong> {t('aimtrain.rules.nextRounds')}</li>
                            <li><strong>{t('aimtrain.rules.continuationLabel')}</strong> {t('aimtrain.rules.continuation')}</li>
                            <li><strong>{t('aimtrain.rules.rewardsLabel')}</strong> {t('aimtrain.rules.rewards')}</li>
                        </ul>
                    </div>

                    <div className={styles.section}>
                        <h3>{t('aimtrain.notes.title')}</h3>
                        <ul>
                            <li>{t('aimtrain.notes.noDownload')}</li>
                            <li>{t('aimtrain.notes.missingMatch')}</li>
                            <li>{t('aimtrain.notes.eliminated')}</li>
                            <li>{t('aimtrain.notes.roundsDepend')}</li>
                            <li>{t('aimtrain.notes.stableConnection')}</li>
                        </ul>
                    </div>
                </div>

                <div className={styles.footer}>
                    <button className={styles.okButton} onClick={onClose}>{t('common.gotIt')}</button>
                </div>
            </div>
        </div>
    );
};

export default AimTrainInstructions;